import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, List, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";

const ManagingMedicationsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);
  const [activeAccordionRightIndexes] = useState([0]);

  const renderAccordionBenefits = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} >  
        <p className={styles.learnMoreAccordionText} >
          As we get older, it can become harder to remember daily tasks like taking medciations.
          <br/><br/>
          Keeping a current medication list for older adults is one of the best ways to help 
          manage their medication but it isn't the only solution.
        </p>
      </Segment>
      </>
    );
  };
  const renderAccordionInvolved = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} >  
        <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
          <>
            <List.Item header="Organize pills in a pillbox" 
              description="There are pillboxes to fit every sort of medication schedule and some have a month capacity with each number corresponding to what day of the month it is." />
            <List.Item header="Set a reminder or alarm to help with forgetfulness" 
              description="Phone alarms can be customized to display text to indicate it is time to take medications." />
            <List.Item header="Help them keep medications in an obvious place where the older adult won't forget them" 
              description="It is also helpful to keep them visible instead of being tucket away in a cabinet or drawer. Visibility is important." />
            <List.Item header="Plan to take medications at the same time every day to establish a habit" 
              description="Taking them around a meal time, if medications allow, is a good way to remember. If your loved one has a companion animal, have them give their animal a small treat everytime they take their medication. Animals are very routine based and they won't their owners forget medication/treat time." />
          </>
        </List>
      </Segment>
      </>
    );
  };

  const accordions = [
    { key: 'benefits',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > What are the Benefits? </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionBenefits()}/>)
      }
    }
  ];

  const accordionsRight = [
    { key: 'involved',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tricks to Help with Medications: </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionInvolved()}/>)
      }
    }
  ];

  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}ManagingMedsLearnMore.png)`, }}>
        <div className={styles.learnMoreModalContent}>

          <Grid stackable columns="equal" style={{width: '100%', height: '100%', paddingLeft: '1em', paddingTop: "1em"}}>
            <Grid.Column >
              <Accordion  panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </Grid.Column>
            <Grid.Column >
              <Accordion  panels={accordionsRight} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionRightIndexes} exclusive={false} />
            </Grid.Column>            
          </Grid>
          
        </div>
      </Segment>      
    </>
  );
};

export default observer(ManagingMedicationsLearnMore);
